import { useEffect, useRef } from "react";

export function useVisiblePolling(task: () => void | Promise<void>, intervalMs: number) {
  const taskRef = useRef(task);
  taskRef.current = task;

  useEffect(() => {
    const runIfVisible = () => {
      if (document.visibilityState === "visible") void taskRef.current();
    };
    const timer = window.setInterval(runIfVisible, intervalMs);
    document.addEventListener("visibilitychange", runIfVisible);
    window.addEventListener("focus", runIfVisible);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", runIfVisible);
      window.removeEventListener("focus", runIfVisible);
    };
  }, [intervalMs]);
}
